/* eslint-disable */

export default function (THREE) {

  let ViewerControls = function ( target, domElement ) {

    this.target = target;

    this.domElement = ( domElement !== undefined ) ? domElement : document;

    // Set to false to disable this control
    this.enabled = true;


    this.autoRotateSpeed = 0.05; 
    this.autoRotateStart = 0.9;

    this.rotateSpeed = 0.5;
    this.panSpeed = 1;
    //
    // public methods
    //

    this.autoRotate = function () {
      state = STATE.AUTO_ROTATE;
      this.target.rotation.x = 0;
      this.target.rotation.y = this.autoRotateStart;
      this.target.rotation.z = 0;
      rotateCounter = 0;
      rotateMax = 2 * Math.PI / this.autoRotateSpeed;
    }
    
    this.reset = function () {
      // reset target object rotation
    };

    this.update = function () {
      if (state === STATE.AUTO_ROTATE) {
        rotateCounter++;
        rotateLeft(this.autoRotateSpeed);
        if (rotateCounter >= rotateMax) {
          state = STATE.NONE;
        }
      }
    };
    
    this.setTarget = function (target) {
      this.target = target;
      state = STATE.NONE;
    }

    this.dispose = function () {

      scope.domElement.removeEventListener( 'contextmenu', onContextMenu, false );
      scope.domElement.removeEventListener( 'mousedown', onMouseDown, false );

      scope.domElement.removeEventListener( 'touchstart', onTouchStart, false );
      scope.domElement.removeEventListener( 'touchend', onTouchEnd, false );
      scope.domElement.removeEventListener( 'touchmove', onTouchMove, false );

      document.removeEventListener( 'mousemove', onMouseMove, false );
      document.removeEventListener( 'mouseup', onMouseUp, false );

    };

    //
    // internals
    //

    var scope = this;
    var rotateCounter = 0;
    var rotateMax = 0;
    window.viewerControls = this;

    var changeEvent = { type: 'change' };
    var startEvent = { type: 'start' };
    var endEvent = { type: 'end' };

    var STATE = { NONE: - 1, ROTATE: 0, TOUCH_ROTATE: 1, AUTO_ROTATE: 2 };

    var state = STATE.NONE;

    var EPS = 0.000001;

    var axisX = new THREE.Vector3(1,0,0);
    var axisY = new THREE.Vector3(0,1,0);
    
    // current position in spherical coordinates
    

    var rotateStart = new THREE.Vector2();
    var rotateEnd = new THREE.Vector2();
    var rotateDelta = new THREE.Vector2();


    function getAutoRotationAngle() {

      return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;

    }


    function rotateLeft( angle ) {

      if (scope.target !== null)
        scope.target.rotateOnWorldAxis(axisY, angle);

    }

    function rotateUp( angle ) {
      if (scope.target !== null)
        scope.target.rotateOnWorldAxis(axisX, angle);

    }


    //
    // event callbacks - update the object state
    //

    function handleMouseDownRotate( event ) {

      //console.log( 'handleMouseDownRotate' );

      rotateStart.set( event.clientX, event.clientY );

    }

    function handleMouseMoveRotate( event ) {

      handleMoveRotate( event.clientX, event.clientY );
      

    }


    function handleMouseUp( event ) {

    }


    function handleTouchStartRotate( event ) {

      rotateStart.set( event.touches[ 0 ].pageX, event.touches[ 0 ].pageY );

    }
    
    function handleMoveRotate (x, y) {
      
      rotateEnd.set( x, y );
      rotateDelta.subVectors( rotateEnd, rotateStart );

      var element = scope.domElement === document ? scope.domElement.body : scope.domElement;

      // rotating across whole screen goes 360 degrees around
      rotateLeft( 2 * Math.PI * rotateDelta.x / element.clientWidth * scope.rotateSpeed );

      // rotating up and down along whole screen attempts to go 360, but limited to 180
      rotateUp( 2 * Math.PI * rotateDelta.y / element.clientHeight * scope.rotateSpeed );

      rotateStart.copy( rotateEnd );

      scope.update();
    }
    
    
    function handleTouchMoveRotate( event ) {
      handleMoveRotate(event.touches[0].pageX, event.touches[0].pageY);
    }



    function handleTouchEnd( event ) {

      //console.log( 'handleTouchEnd' );

    }

    //
    // event handlers - FSM: listen for events and reset state
    //

    function onMouseDown( event ) {

      if ( scope.enabled === false ) return;

      event.preventDefault();

      switch ( event.button ) {

        case 0 :
          handleMouseDownRotate( event );

          state = STATE.ROTATE;

          break;

      }

      if ( state !== STATE.NONE ) {

        document.addEventListener( 'mousemove', onMouseMove, false );
        document.addEventListener( 'mouseup', onMouseUp, false );

        scope.dispatchEvent( startEvent );

      }

    }

    function onMouseMove( event ) {

      if ( scope.enabled === false ) return;

      event.preventDefault();

      switch ( state ) {

        case STATE.ROTATE:

          handleMouseMoveRotate( event );

          break;


      }

    }

    function onMouseUp( event ) {

      if ( scope.enabled === false ) return;

      handleMouseUp( event );

      document.removeEventListener( 'mousemove', onMouseMove, false );
      document.removeEventListener( 'mouseup', onMouseUp, false );

      scope.dispatchEvent( endEvent );

      state = STATE.NONE;

    }

    function onTouchStart( event ) {

      if ( scope.enabled === false ) return;

      switch ( event.touches.length ) {

        case 1:	// one-fingered touch: rotate

          if ( scope.enableRotate === false ) return;

          handleTouchStartRotate( event );

          state = STATE.TOUCH_ROTATE;

          break;


        default:

          state = STATE.NONE;

      }

      if ( state !== STATE.NONE ) {

        scope.dispatchEvent( startEvent );

      }

    }

    function onTouchMove( event ) {

      if ( scope.enabled === false ) return;

      event.preventDefault();
      event.stopPropagation();

      switch ( event.touches.length ) {

        case 1: // one-fingered touch: rotate

          if ( scope.enableRotate === false ) return;
          if ( state !== STATE.TOUCH_ROTATE ) return; // is this needed?...

          handleTouchMoveRotate( event );

          break;

        default:

          state = STATE.NONE;

      }

    }

    function onTouchEnd( event ) {

      if ( scope.enabled === false ) return;

      handleTouchEnd( event );

      scope.dispatchEvent( endEvent );

      state = STATE.NONE;

    }

    function onContextMenu( event ) {

      if ( scope.enabled === false ) return;

      event.preventDefault();

    }

    //

    scope.domElement.addEventListener( 'contextmenu', onContextMenu, false );

    scope.domElement.addEventListener( 'mousedown', onMouseDown, false );

    scope.domElement.addEventListener( 'touchstart', onTouchStart, false );
    scope.domElement.addEventListener( 'touchend', onTouchEnd, false );
    scope.domElement.addEventListener( 'touchmove', onTouchMove, false );

    // force an update at start

    this.update();

  };

  ViewerControls.prototype = Object.create( THREE.EventDispatcher.prototype );
  ViewerControls.prototype.constructor = ViewerControls;

  Object.defineProperties( ViewerControls.prototype, {

  } );
  return ViewerControls;
}


// WEBPACK FOOTER //
// ./src/ViewerControls.js